/**
 *
 * @author: Matthew Rawson @ 08/08/2018 09:02
 * @description:
 * @notes:
 */
import styled from "styled-components"

import {minWidthMedia} from "@irati/ui/src/global/media"

export default styled.div`
  display: flex;
  align-self: flex-start;
  justify-content: space-between;
  flex-direction: column;

  ${minWidthMedia.desktop`
    flex-direction: row;
    white-space: nowrap;
  `}
`
